module.exports = "/_next/static/images/dollar-monotone-cb28a635454f4444ef72cebccce3fae8.svg";